function noop() {}

function assign(tar, src) {
	for (var k in src) tar[k] = src[k];
	return tar;
}

function assignTrue(tar, src) {
	for (var k in src) tar[k] = 1;
	return tar;
}

function appendNode(node, target) {
	target.appendChild(node);
}

function insertNode(node, target, anchor) {
	target.insertBefore(node, anchor);
}

function detachNode(node) {
	node.parentNode.removeChild(node);
}

function reinsertChildren(parent, target) {
	while (parent.firstChild) target.appendChild(parent.firstChild);
}

function createElement(name) {
	return document.createElement(name);
}

function createText(data) {
	return document.createTextNode(data);
}

function setAttribute(node, attribute, value) {
	node.setAttribute(attribute, value);
}

function blankObject() {
	return Object.create(null);
}

function destroy(detach) {
	this.destroy = noop;
	this.fire('destroy');
	this.set = noop;

	if (detach !== false) this._fragment.u();
	this._fragment.d();
	this._fragment = null;
	this._state = {};
}

function _differs(a, b) {
	return a != a ? b == b : a !== b || ((a && typeof a === 'object') || typeof a === 'function');
}

function fire(eventName, data) {
	var handlers =
		eventName in this._handlers && this._handlers[eventName].slice();
	if (!handlers) return;

	for (var i = 0; i < handlers.length; i += 1) {
		var handler = handlers[i];

		if (!handler.__calling) {
			handler.__calling = true;
			handler.call(this, data);
			handler.__calling = false;
		}
	}
}

function get() {
	return this._state;
}

function init(component, options) {
	component._handlers = blankObject();
	component._bind = options._bind;

	component.options = options;
	component.root = options.root || component;
	component.store = component.root.store || options.store;
}

function on(eventName, handler) {
	var handlers = this._handlers[eventName] || (this._handlers[eventName] = []);
	handlers.push(handler);

	return {
		cancel: function() {
			var index = handlers.indexOf(handler);
			if (~index) handlers.splice(index, 1);
		}
	};
}

function set(newState) {
	this._set(assign({}, newState));
	if (this.root._lock) return;
	this.root._lock = true;
	callAll(this.root._beforecreate);
	callAll(this.root._oncreate);
	callAll(this.root._aftercreate);
	this.root._lock = false;
}

function _set(newState) {
	var oldState = this._state,
		changed = {},
		dirty = false;

	for (var key in newState) {
		if (this._differs(newState[key], oldState[key])) changed[key] = dirty = true;
	}
	if (!dirty) return;

	this._state = assign(assign({}, oldState), newState);
	this._recompute(changed, this._state);
	if (this._bind) this._bind(changed, this._state);

	if (this._fragment) {
		this.fire("state", { changed: changed, current: this._state, previous: oldState });
		this._fragment.p(changed, this._state);
		this.fire("update", { changed: changed, current: this._state, previous: oldState });
	}
}

function callAll(fns) {
	while (fns && fns.length) fns.shift()();
}

function _mount(target, anchor) {
	this._fragment[this._fragment.i ? 'i' : 'm'](target, anchor || null);
}

function _unmount() {
	if (this._fragment) this._fragment.u();
}

var proto = {
	destroy,
	get,
	fire,
	on,
	set,
	_recompute: noop,
	_set,
	_mount,
	_unmount,
	_differs
};

/* src/Scroller.html generated by Svelte v2.4.1 */

const scrollers = [];

if (typeof window !== 'undefined') {
	window.addEventListener('scroll', () => {
		scrollers.forEach(scroller => {
			scroller.handleScroll();
		});
	});
}

let manager;

if (typeof IntersectionObserver !== 'undefined') {
	const map = new Map();

	const observer = new IntersectionObserver((entries, observer) => {
		entries.forEach(entry => {
			const scroller = map.get(entry.target);
			const index = scrollers.indexOf(scroller);

			if (entry.isIntersecting) {
				if (index === -1) scrollers.push(scroller);
			} else {
				scroller.handleScroll();
				if (index !== -1) scrollers.splice(index, 1);
			}
		});
	}, {
		rootMargin: '400px 0px'
	});

	manager = {
		add: scroller => {
			const { outer } = scroller.refs;
			const { top, bottom } = outer.getBoundingClientRect();

			if (top < window.innerHeight && bottom > 0) scrollers.push(scroller);

			map.set(outer, scroller);
			observer.observe(outer);
		},

		remove: scroller => {
			const index = scrollers.indexOf(scroller);
			if (index !== -1) scrollers.splice(index, 1);

			map.delete(scroller.refs.outer);
			observer.unobserve(scroller.refs.outer);
		}
	};
} else {
	manager = {
		add: scroller => {
			scrollers.push(scroller);
		},

		remove: scroller => {
			const index = scrollers.indexOf(scroller);
			if (index !== -1) scrollers.splice(index, 1);
		}
	};
}

function top_px({ top, wh }) {
	return Math.round(top * wh);
}

function bottom_px({ bottom, wh }) {
	return Math.round(bottom * wh);
}

function threshold_px({ threshold, wh }) {
	return Math.round(threshold * wh);
}

function style({ fixed, offset_top, bottom_px, top_px, width, height, inverted }) {
	return `
		position: ${fixed ? 'fixed' : 'absolute'};
		top: 0;
		transform: translate(0, ${offset_top}px);
		width: ${width}px;
		z-index: ${inverted ? 3 : 1};
	`;
}
function data() {
	return {
		top: 0,
		bottom: 1,
		threshold: 0.5,

		count: 0,
		index: 0,
		offset: 0,
		progress: 0,

		query: 'section'
	};
}
var methods = {
	handleScroll() {
		const { top_px, bottom_px, threshold_px, parallax } = this.get();

		// determine fix state
		const foreground = this.refs.foreground.getBoundingClientRect();
		const background = this.refs.background.getBoundingClientRect();

		const foreground_height = foreground.bottom - foreground.top;
		const background_height = background.bottom - background.top;

		const available_space = bottom_px - top_px;
		const p = (top_px - foreground.top) / (foreground_height - available_space);

		const { sections } = this;

		let offset_top;
		let fixed;
		let index;
		let offset;

		if (p <= 0) {
			offset_top = 0;
			fixed = false;
			offset = 0;
			index = -1;
		} else if (p >= 1) {
			offset_top = parallax
				? (foreground_height - background_height)
				: (foreground_height - available_space);
			fixed = false;
			offset = 1;
			index = sections.length - 1;
		} else {
			offset_top = parallax ?
				Math.round(top_px - p * (background_height - available_space)) :
				top_px;
			fixed = true;

			for (index = 0; index < this.sections.length; index += 1) {
				const section = this.sections[index];
				const { top } = section.getBoundingClientRect();

				const next = this.sections[index + 1];
				const bottom = next ? next.getBoundingClientRect().top : this.refs.foreground.getBoundingClientRect().bottom;

				if (bottom >= threshold_px) {
					offset = (threshold_px - top) / (bottom - top);
					break;
				}
			}
		}

		this.set({
			progress: p,
			index,
			offset,

			offset_top,
			fixed
		});
	},

	handleResize() {
		const { left, right } = this.refs.outer.getBoundingClientRect();

		const bg = this.refs.background.getBoundingClientRect();
		const fg = this.refs.foreground.getBoundingClientRect();

		this.set({
			width: right - left,
			foreground_height: fg.bottom - fg.top,
			background_height: bg.bottom - bg.top,
			left
		});
	}
};

function oncreate() {
	this.sections = this.refs.foreground.querySelectorAll(this.get().query);
	this.set({ count: this.sections.length });

	this.handleResize();
	this.handleScroll();

	this.on('state', ({ changed }) => {
		if (changed.top || changed.threshold || changed.bottom || changed.parallax) {
			this.handleScroll();
		}
	});

	manager.add(this);
}
function ondestroy() {
	manager.remove(this);
}
function add_css() {
	var style = createElement("style");
	style.id = 'svelte-7ydq3l-style';
	style.textContent = "[svelte-ref-outer].svelte-7ydq3l{position:relative}[svelte-ref-background].svelte-7ydq3l{position:relative;width:100%}[svelte-ref-foreground].svelte-7ydq3l{position:relative;z-index:2}[svelte-ref-foreground].svelte-7ydq3l::after{content:' ';display:block;clear:both}.background-container.svelte-7ydq3l{position:absolute;width:100%;pointer-events:none;will-change:transform}";
	appendNode(style, document.head);
}

function create_main_fragment(component, ctx) {
	var div, div_1, div_2, slot_content_background = component._slotted.background, text_2, div_3, slot_content_foreground = component._slotted.foreground;

	function onwindowresize(event) {
		component.handleResize();	}
	window.addEventListener("resize", onwindowresize);

	function onwindowresize_1(event) {
		component.set({
			wh: this.innerHeight
		});
	}
	window.addEventListener("resize", onwindowresize_1);

	return {
		c() {
			div = createElement("div");
			div_1 = createElement("div");
			div_2 = createElement("div");
			text_2 = createText("\n\n\t");
			div_3 = createElement("div");
			setAttribute(div, "svelte-ref-outer", "");
			setAttribute(div_2, "svelte-ref-background", "");
			div_2.className = "svelte-7ydq3l";
			div_1.className = "background-container svelte-7ydq3l";
			div_1.style.cssText = ctx.style;
			setAttribute(div_3, "svelte-ref-foreground", "");
			div_3.className = "svelte-7ydq3l";
			div.className = "svelte-7ydq3l";
		},

		m(target, anchor) {
			insertNode(div, target, anchor);
			appendNode(div_1, div);
			appendNode(div_2, div_1);

			if (slot_content_background) {
				appendNode(slot_content_background, div_2);
			}

			component.refs.background = div_2;
			appendNode(text_2, div);
			appendNode(div_3, div);

			if (slot_content_foreground) {
				appendNode(slot_content_foreground, div_3);
			}

			component.refs.foreground = div_3;
			component.refs.outer = div;
		},

		p(changed, ctx) {
			if (changed.style) {
				div_1.style.cssText = ctx.style;
			}
		},

		u() {
			detachNode(div);

			if (slot_content_background) {
				reinsertChildren(div_2, slot_content_background);
			}

			if (slot_content_foreground) {
				reinsertChildren(div_3, slot_content_foreground);
			}
		},

		d() {
			window.removeEventListener("resize", onwindowresize);

			window.removeEventListener("resize", onwindowresize_1);

			if (component.refs.background === div_2) component.refs.background = null;
			if (component.refs.foreground === div_3) component.refs.foreground = null;
			if (component.refs.outer === div) component.refs.outer = null;
		}
	};
}

function Scroller(options) {
	init(this, options);
	this.refs = {};
	this._state = assign(data(), options.data);
	this._state.wh = window.innerHeight;
	this._recompute({ top: 1, wh: 1, bottom: 1, threshold: 1, fixed: 1, offset_top: 1, bottom_px: 1, top_px: 1, width: 1, height: 1, inverted: 1 }, this._state);

	this._handlers.destroy = [ondestroy];

	this._slotted = options.slots || {};

	if (!document.getElementById("svelte-7ydq3l-style")) add_css();

	if (!options.root) {
		this._oncreate = [];
	}

	this.slots = {};

	this._fragment = create_main_fragment(this, this._state);

	this.root._oncreate.push(() => {
		oncreate.call(this);
		this.fire("update", { changed: assignTrue({}, this._state), current: this._state });
	});

	if (options.target) {
		this._fragment.c();
		this._mount(options.target, options.anchor);

		callAll(this._oncreate);
	}
}

assign(Scroller.prototype, proto);
assign(Scroller.prototype, methods);

Scroller.prototype._recompute = function _recompute(changed, state) {
	if (changed.top || changed.wh) {
		if (this._differs(state.top_px, (state.top_px = top_px(state)))) changed.top_px = true;
	}

	if (changed.bottom || changed.wh) {
		if (this._differs(state.bottom_px, (state.bottom_px = bottom_px(state)))) changed.bottom_px = true;
	}

	if (changed.threshold || changed.wh) {
		if (this._differs(state.threshold_px, (state.threshold_px = threshold_px(state)))) changed.threshold_px = true;
	}

	if (changed.fixed || changed.offset_top || changed.bottom_px || changed.top_px || changed.width || changed.height || changed.inverted) {
		if (this._differs(state.style, (state.style = style(state)))) changed.style = true;
	}
};

export default Scroller;
